var map = {
	"./djf_dd_button.svg": 6944,
	"./djf_fox_head.svg": 3580,
	"./djf_info_blank.svg": 9503,
	"./djf_info_blue.svg": 1425,
	"./djf_info_white.svg": 3500,
	"./djf_logo.svg": 3542,
	"./djf_search.svg": 2183,
	"./djf_star.svg": 8455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7587;